export default __webpack_public_path__ + "static/media/about-me-img.3734d48e.jpg";